module.exports = __webpack_public_path__ + "static/media/product-profile.b7bba2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-profile.png
// module id = 1272
// module chunks = 0